<template>
  <div>
    <workspace-projects-list></workspace-projects-list>
  </div>
</template>
<script>
import WorkspaceProjectsList from '#/ui/Components/Workspace/WorkspaceProjectsList.vue';

export default {
  components: { WorkspaceProjectsList },
};
</script>
